import React from "react";
import { Typography } from "@mui/material";
import TopSection from "../../Components/Common/Top/TopSection";
import ProfitCenterSelection from "./ProfitCenterSelection";


const ProfitCenter = () => {
  return (
    <>
      <TopSection
        labelList={[
          { title: "Home", path: "/dashboard" },
          { title: "History" },
        ]}
        title="Profit Center"
      />
       <div className="container">
        <ProfitCenterSelection />
      </div>
    </>
  );
};

export default ProfitCenter;